var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRightBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51398 7.07147L0.563976 2.12147C0.381818 1.93287 0.281024 1.68027 0.283302 1.41807C0.28558 1.15587 0.390749 0.905059 0.576157 0.719651C0.761566 0.534243 1.01238 0.429074 1.27457 0.426796C1.53677 0.424517 1.78937 0.525312 1.97798 0.70747L7.63498 6.36447C7.82245 6.552 7.92776 6.80631 7.92776 7.07147C7.92776 7.33663 7.82245 7.59094 7.63498 7.77847L1.97798 13.4355C1.78937 13.6176 1.53677 13.7184 1.27457 13.7161C1.01238 13.7139 0.761566 13.6087 0.576157 13.4233C0.390749 13.2379 0.28558 12.9871 0.283302 12.7249C0.281024 12.4627 0.381818 12.2101 0.563976 12.0215L5.51398 7.07147Z",
    fill: "#6B7AE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightBlue);
export default __webpack_public_path__ + "static/media/chevron-right-blue.af3c9212b11fe536e99c2ca048d3ab34.svg";
export { ForwardRef as ReactComponent };